import DefaultModal from "../default";
import { ReactNode } from "react";
import "../modal.scss";
import { useDispatch } from "react-redux";
import { loadingBtnSelector, setMessage } from "store/commonSlice";
import LoadingButton from "components/button/loadingButton";
import { useSelector } from "react-redux";

type IProps = {
  title: string | undefined;
  canclBntText?: string;
  cnfrmBtnText?: string;
  isConfirm?: boolean;
  isCancel?: boolean;
  isOpen: boolean;
  handleCloseModal(): void;
  handleClick?(): void;
  handleCancel?() :void;
  handleKeyDown?(e: React.KeyboardEvent<HTMLInputElement>): void;
  children: ReactNode;
};

const NotiModal = ({
  title,
  canclBntText = "취소",
  cnfrmBtnText = "확인",
  isCancel = false,
  isConfirm = false,
  isOpen,
  handleCloseModal,
  handleClick,
  handleCancel,
  children,
}: IProps) => {
  const dispatch = useDispatch();

  const { isLoading, disabled } = useSelector(loadingBtnSelector);

  return (
    <DefaultModal
      isOpen={isOpen}
      styles="max-w-[31.25rem]"
      handleCloseModal={handleCloseModal}
    >
      <div className="title">
        <h4 className="text-base">{title}</h4>
        <button onClick={handleCloseModal} />
      </div>
      <div className="mt-[-1.875rem]">{children}</div>
      <div className="flex justify-center mt-4 gap-5">
        <LoadingButton
          txt={cnfrmBtnText}
          styles="btn-search"
          isLoading={isLoading}
          disabled={disabled}
          onClick={!isConfirm ? handleCloseModal : handleClick}
        />

        <button
          className={isCancel ? "btn-reset" : "hidden"}
          onClick={handleCancel ? handleCancel : handleCloseModal}
        >
          {canclBntText}
        </button>
      </div>
    </DefaultModal>
  );
};

export default NotiModal;
